import React from 'react';

interface ServiceDetailProps {
    service: {
        icon: string;
        title: string;
        desc: string;
        content: string;
        color: string;
        bg: string;
        image: string;
    };
    onBack: () => void;
}

const ServiceDetail: React.FC<ServiceDetailProps> = ({ service, onBack }) => {
    return (
        <article className="animate-fade-in-up bg-white dark:bg-background-dark min-h-full">
            {/* Stick Header / Back Button */}
            <div className="sticky top-0 z-20 bg-white/80 dark:bg-background-dark/80 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 px-4 py-4 flex items-center justify-between">
                <button
                    onClick={onBack}
                    className="flex items-center gap-2 text-gray-500 hover:text-primary transition-colors font-bold"
                >
                    <span className="material-icons-round">arrow_back</span>
                    Back to Services
                </button>
                <div className="flex items-center gap-2">
                    <div className={`w-8 h-8 rounded-lg ${service.bg} ${service.color} flex items-center justify-center`}>
                        <span className="material-icons-round text-lg">{service.icon}</span>
                    </div>
                    <span className="font-bold text-sm hidden sm:inline">{service.title}</span>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-4 py-12">
                {/* Hero Image */}
                <div className="relative aspect-[21/9] rounded-[2.5rem] overflow-hidden mb-12 shadow-2xl">
                    <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-bottom p-8 sm:p-12">
                        <h1 className="text-4xl sm:text-6xl font-extrabold text-white mt-auto tracking-tight">
                            {service.title}
                        </h1>
                    </div>
                </div>

                {/* Content Block */}
                <div className="prose prose-lg dark:prose-invert max-w-none">
                    <p className="text-xl text-gray-600 dark:text-gray-400 font-medium leading-relaxed mb-8">
                        {service.desc}
                    </p>

                    <div
                        className="text-gray-700 dark:text-gray-300 space-y-6 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: service.content }}
                    />

                    <div className="mt-16 p-8 rounded-3xl bg-primary-light/5 dark:bg-primary/5 border border-primary-light/10 dark:border-primary/10 flex flex-col sm:flex-row items-center justify-between gap-8">
                        <div>
                            <h3 className="text-2xl font-bold mb-2">Ready to schedule an visit?</h3>
                            <p className="text-gray-500">Our specialists are available 24/7 for your pet's needs.</p>
                        </div>
                        <button className="bg-primary hover:bg-primary-dark text-white font-bold px-8 py-4 rounded-2xl transition-all shadow-xl shadow-primary/20 whitespace-nowrap">
                            Book Consultation
                        </button>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default ServiceDetail;
